import { css } from "@compiled/react";

import AvatarGroup from "@atlaskit/avatar-group";
import { token } from "@atlaskit/tokens";

import { Actor } from "./types";

const expandGroupButtonContainerStyles = css({
    display: "flex",
    alignItems: "center",
    gap: token("space.100"),
    marginBlockStart: token("space.100"),
    paddingInlineStart: token("space.300"),
    width: "100%"
});

const avatarContainerStyles = css({
    marginInlineEnd: token("space.050")
});

const expandButtonStyles = css({
    "cursor": "pointer",
    "color": token("color.link"),
    "border": "none",
    "background": "none",
    "padding": 0,
    "font": "inherit",
    "fontSize": "14px",
    "&:hover": {
        textDecoration: "underline"
    }
});

export interface ExpandGroupButtonProps {
    additionalActors: Actor[];
    notificationCount: number;
    onToggle: () => void;
    isExpanded: boolean;
}

export const ExpandGroupButton = ({
    additionalActors,
    notificationCount,
    onToggle,
    isExpanded
}: ExpandGroupButtonProps) => {
    const avatars = additionalActors.map((actor) => ({
        src: actor.avatarUrl,
        name: actor.displayName
    }));

    const buttonLabel = isExpanded
        ? "Show less"
        : `+${notificationCount} updates from ${additionalActors[0]?.displayName} and others`;

    return (
        <div css={expandGroupButtonContainerStyles}>
            {!isExpanded && (
                <div css={avatarContainerStyles}>
                    <AvatarGroup data={avatars} size="small" />
                </div>
            )}
            <button
                css={expandButtonStyles}
                type="button"
                onClick={onToggle}
                data-testid="notification-group-expand-button"
            >
                {buttonLabel}
            </button>
        </div>
    );
};
